import { render } from "./FooterText.vue?vue&type=template&id=b07ee57c&scoped=true"
import script from "./FooterText.vue?vue&type=script&lang=js"
export * from "./FooterText.vue?vue&type=script&lang=js"

import "./FooterText.vue?vue&type=style&index=0&id=b07ee57c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07ee57c"]])

export default __exports__